import { Box } from "@material-ui/core";
import { NewCheckMarkRoundIcon } from "../../../../assets/icons/icon";
import { ParagraphText, UBButton } from "../../../../Libraries";
import { useContext } from "react";
import { LanguageContext } from "../../../../context/LanguageContext";
import styles from "./styles.module.css";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

const SuccessfullyUpdatePin = ({ handleReset }) => {
  const [I18n] = useContext(LanguageContext);
  return (
    <Box className={styles.ActivatedPinCodeContainer}>
      <NewCheckMarkRoundIcon width="60px" height="60px" />

      <Box className={styles.pinUpdatedHeadingContainer}>
        <ParagraphText
          className={`fontWeight500 fontSize24 newFontColor`}
        >
          {I18n.pin_updated_successfully}
        </ParagraphText>
      </Box>

      <Box className={styles.updatedSuccessfullyCtaContainer}>
        <UBButton
          id="successfully_pin_updated_done_btn"
          onClick={() => { triggerLogEvent(analytics, "setting_pin_success"); handleReset(); }}
          title={I18n.done}
          className="ubPrimaryButton fontSize14 fontWeight400 textUppercase"
        />
      </Box>
    </Box>
  );
};

export default SuccessfullyUpdatePin;
